import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). The color-bearing
// CommonStyles.white_bg spread is replaced with an explicit themed
// backgroundColor (identical in light).
const makeStyles = colors =>
  StyleSheet.create({
    mainView: {
      ...CommonStyles.full_flex,
      backgroundColor: colors.background,
      ...CommonStyles.pt_56,
      ...CommonStyles.pb_56,
    },
    input: {
      ...CommonStyles.mt_32,
      ...CommonStyles.max_width_292,
    },
    requestNowButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_16,
    },
    backPressable: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_32,
    },
  });

export default makeStyles;
